import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { TOAST_CONFIG, TOAST_IDS } from '../../const';
import { logger } from '../../utils/logger';

const ErrorLogger = (props) => {
  const { error, forceShow } = props;

  logger.log('errorlogger', error);

  useEffect(() => {
    if (error && forceShow) {
      toast.dismiss();
      toast.error(error, {
        ...TOAST_CONFIG,
        toastId: TOAST_IDS.ERROR,
      });
    }
  }, [error, forceShow]);
  // if (error) {
  //   return <Wrapper {...props}>{/* {error} */}</Wrapper>;
  // }
  return null;
};

const Wrapper = styled.div`
  // color: red;
  // margin-bottom: 10px;
  // margin-top: 10px;

  // position: absolute;
`;
export default ErrorLogger;
